const FIVE_NUMBER = 5;
const IMAGE_RESOLUTION = 1000;

export const MAX_FILE_AMOUNT = 5;
export const MAX_FILE_SIZE = FIVE_NUMBER * IMAGE_RESOLUTION * IMAGE_RESOLUTION;
export const acceptedFileUploadFilesTypes =
  '.log, .png, .jpg, .jpeg, .mov, mp4, .avi';
